import axios from 'axios'
import Cookie from 'js-cookie'

const instance = axios.create({
  baseURL: '',
  timeout: 500000
})

instance.interceptors.request.use((req) => {
  req.headers.authorization = Cookie.get('staffToken')
  return req
}, err => Promise.reject(err))

instance.interceptors.response.use(
  res => res,
  err => Promise.reject(err)
)

export default function request (url, options) {
  const opt = options || {}
  opt.config = opt.config || {}
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-Type': 'application/json'
    }
    instance({
      url,
      method: opt.type || 'get',
      data: opt.params || {},
      ...opt.config,
      headers: opt.headers ? { ...headers, ...opt.headers } : { ...headers }
    }).then((res) => {
      if (res) {
        if (res.headers['content-type'] && (res.headers['content-type'].includes('application/octet-stream') ||
        res.headers['content-type'].includes('application/vnd.ms-excel') ||
        res.headers['content-type'].includes('application/x-msdownload'))) {
          // 取文件名
          resolve(res.data)
        }
        const h = res.headers
        resolve({ data: res.data, headers: h })
      }
      return res
    })
      .catch((err) => { reject(err) })
  })
}
